// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"01597c8c","243":"2396a7d0","920":"60017bd2","967":"71a3221b"}[chunkId] + ".chunk.js";
};